"use strict";

exports.__esModule = true;
exports.default = void 0;

var _emotion = require("emotion");

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype.__proto__ = superClass && superClass.prototype;
  subClass.__proto__ = superClass;
}

var getRandomColor = function getRandomColor() {
  var colors = ['#f6d8d8', '#ffe4ff', '#dcebff', '#bbffbb', '#ffffd2', '#ffb3b3', '#d1b3ff', '#ddff99', '#99ddff', '#ffd9b3'];
  var index = parseInt(Math.random() * colors.length, 10);
  return colors[index];
};

var placeholder = function placeholder(isLoading) {
  return /*#__PURE__*/(0, _emotion.css)("transition:background 0.2s ease;background:", isLoading ? getRandomColor() : 'inherit', ";");
};

var imageStyles = function imageStyles(isLoading) {
  return /*#__PURE__*/(0, _emotion.css)("opacity:", isLoading ? 0 : 1, ";transition:opacity ease 0.4s;");
};

var LazyImage = /*#__PURE__*/function (_React$Component) {
  function LazyImage(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      isLoading: true
    };
    return _this;
  }

  var _proto = LazyImage.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var src = this.props.src;
    this.handleImage(src);
  };

  _proto.handleImage = function handleImage(src) {
    var _this2 = this;

    var image = new Image();
    image.src = src;

    image.onload = function () {
      _this2.setState({
        src: src,
        isLoading: false
      });
    };
  };

  _proto.render = function render() {
    var _this$props = this.props,
        alt = _this$props.alt,
        rest = _objectWithoutProperties(_this$props, ["alt"]);

    var _this$state = this.state,
        isLoading = _this$state.isLoading,
        src = _this$state.src;
    return _react.default.createElement("div", {
      className: (0, _emotion.css)(placeholder(isLoading))
    }, _react.default.createElement("img", _extends({
      src: src,
      alt: alt,
      className: (0, _emotion.css)(imageStyles(isLoading))
    }, rest)));
  };

  _inheritsLoose(LazyImage, _React$Component);

  return LazyImage;
}(_react.default.Component);

LazyImage.propTypes = {
  alt: _propTypes.string,
  src: _propTypes.string
};
var _default = LazyImage;
exports.default = _default;